import CrudTable from './CrudTable';
import { endpoints } from '../../services/api';

const Consignatarios = () => {
  return (
    <CrudTable
      title="Consignatarios"
      apiEndpoint={endpoints.oficina.consignatarios}
      columns={[
        { key: 'nombre', label: 'Nombre' },
        { key: 'direccion', label: 'Dirección' }
      ]}
      formFields={[
        { name: 'nombre', label: 'Nombre', required: true },
        { name: 'direccion', label: 'Dirección', type: 'textarea' }
      ]}
    />
  );
};

export default Consignatarios;

